import axios from "axios";
import React, { FC, useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import "../workers/WorkerCategories.css"
import editIcon from "../../../assets/img/small-logos/edit_icon.svg"
import deleteIcon from "../../../assets/img/small-logos/delete _icon.svg";
import Swal from "sweetalert2";
import eye from "../../../assets/img/icons/eye-solid.svg"
import "./DoorstepServices.css"
// import { IService } from "src/helper/interfaces";
// import { IDoorstepCategory } from "src/helper/interfaces";
import Cookies from "js-cookie";
import Paginator from "src/components/layout/Paginator";
// import edit from "../../../assets/img/icons/icons8-edit.svg"
// import placeholderImg from "../../../assets/img/landscape-placeholder-svgrepo-com.svg";
// import { useBackContext } from "src/hooks/context/BackContext";
import { Link } from "react-router-dom";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import LoadingGif from "src/components/layout/Loader";
interface InitialValuesType {
   _id: string;
   about: string;
   category_name: string;
   createdAt: string; // Consider using Date type if you need date manipulation
   description: string[];
   doorstep_category_id: string;
   price_per_half_hour: string;
   price_per_hour: string;
   service_image: string | null;
   service_providers: string[];
   service_title: string;
   service_type: string;
}

const getAllServices = async (token: string, pageNumber: number, pageSize: number, searchValue: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/doorstep-services`, {
      headers: {
         "x-access-token": token
      },
      params: {
         service_type: "normal_worker",
         page: pageNumber,
         search_value: searchValue,
         pageSize: pageSize
      }

   })
};
const getAllCategories = async (token: string, pageSize: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/doorstep-categories`, {
      headers: {
         "x-access-token": token
      },
      params: {
         pageSize
      }
   })
};
type InputValues = {
   [key: string]: string;
};


const DoorstepServices = () => {

   const Token = Cookies.get("token");
   const [confirmDel, setConfirmDel] = useState(false);
   const [searchVal, setSearchVal] = useState("");
   const [doorStepServices, setDoorstepServices] = useState<any[]>([])
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state?.loading?.value);

   useEffect(() => {
      dispatch(startLoading());

      getAllServices(Token as string, pageNo, pageSize, searchVal).then((res) => {
         // console.log(res)
         if (res?.data?.status_code === 200) {
            setDoorstepServices(res?.data?.data?.data);
            setTotalPages(res?.data?.data?.totalPages);

         } else {

            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: `${res?.data?.data?.msg}`,
               footer: '<a href="#">Why do I have this issue?</a>'
            });
         }
      }).catch(err => {
         console.log(err)
      }).finally(() => {
         dispatch(stopLoading());
      })
   }, [Token, pageNo, searchVal, confirmDel])


   const handleDeleteConfirmed = (id: string) => {
      // console.log(id);
      if (Token === undefined) {
         console.error("Token is undefined");
         return;
      }
      dispatch(startLoading())
      // Dispatch the delete action here
      Swal.fire({
         title: 'Are you sure?',
         text: "You won't be able to revert this!",
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'Yes, delete it!'
      }).then(async (response) => {
         if (response.isConfirmed) {
            // console.log("lamao")
            await axios({
               url: `${AppConfig.DEV_SERVER}/doorstep-service/${id}`,
               method: "DELETE",
               headers: {
                  'content-type': 'multipart/form-data',
                  "x-access-token": Token,
               }
            }).then((res) => {
               // console.log(res)
               if (res?.data?.status_code === 200) {
                  setConfirmDel(!confirmDel)

                  Swal.fire(
                     'Deleted!',
                     `${res?.data?.msg}`,
                     'success'
                  )
               }
               else {
                  Swal.fire(
                     'Oops...!',
                     `${res?.data?.msg}`,
                     'error'
                  );
               }


            }).catch((err) => {
               console.log(err)
            })  // Clear the selectedFoodItem state after updating
            // setModalShow(false);
         }
      }
      ).catch(err => {
         console.log(err)
      }).finally(() => {
         dispatch(stopLoading());
      })
   };


   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };

   return (
      <MainLayout
         showAllFilters={false}
         searchValue={searchVal}
         onChange={(e) => setSearchVal(e.target.value)}
         clearValChange={clearSearchValue}
      >

         <div className="mt-3 mb-3">
            {
               loading ?
                  <div>
                     <LoadingGif />
                  </div>

                  : ""
            }
            <div className="card category-main me-2 p-3 p-md-4">
               <div>
                  <div className="d-flex justify-content-end mb-2">

                     <div className="d-flex justify-content-end gap-4 w-40">
                        <Link to={`/doorstep/services/create`}>

                           <span className="add-cat">
                              <button className="add-cat-btn">Add Service</button>
                           </span>
                        </Link>
                     </div>

                  </div>
                  <div className="table-extra-responsive">
                     <table className="table table-striped card-body">
                        <thead>
                           <tr className="category-tr">
                              {/* <th scope="col" className="text-start ps-4">name</th> */}
                              <th scope="col" className="text-start ps-4">Sr.No.</th>
                              <th scope="col" className="text-start ps-4">Service Id</th>
                              <th scope="col" className="text-start ps-4">Service Name</th>
                              <th scope="col" className="text-start ps-4">Category Name</th>
                              <th scope="col" className="text-start ps-4">Hourly Price</th>
                              {/* <th scope="col-2" className="text-start ps-4">Providers</th> */}


                              <th scope="col" className="text-start ps-4">Icon</th>
                              <th scope="col" className="col-lg-2 cat_btns">Action</th>
                           </tr>
                        </thead>
                        <tbody>
                           {
                              doorStepServices && doorStepServices?.map((data, i) => {

                                 // const res = Providers?.join(", ")
                                 const rowNumber = (pageNo - 1) * pageSize + (i + 1);
                                 return (
                                    <tr key={data?._id}>
                                       {/* <th scope="row" className="text-start ps-4 pt-3">{data?.position}</th> */}
                                       <td className="text-start ps-4 pt-3">{rowNumber}</td>
                                       <td className="text-start col-2 ps-4 pt-3">{data?._id}</td>
                                       <td className="text-start ps-4 pt-3">{data?.service_title}</td>
                                       <td className="text-start ps-4 pt-3">{data?.category_name}</td>
                                       <td className="text-start ps-4 pt-3"> &#8377; {data?.price_per_hour}</td>
                                       {/* <td className="text-start ps-4 pt-3">{Providers}</td> */}

                                       <td className="icon-td text-start ps-4">
                                          <img src={data?.service_image} alt="categories" style={{ height: "70px", width: "100px" }} />
                                       </td>


                                       <td className="align-content-center ">
                                          <div className="d-flex justify-content-center gap-3">
                                             <Link to={`/doorstep/services/edit/${data?._id}`}>
                                                <button className="btn btn-sm edit_btn">
                                                   <img src={editIcon} />
                                                </button>
                                             </Link>
                                             <Link to={`/doorstep/services/${data?._id}`}>

                                                <button className="btn btn-sm delete_btn ">
                                                   <img src={eye} />
                                                </button>
                                             </Link>
                                             <button className="btn btn-sm delete_btn " onClick={() => handleDeleteConfirmed(data?._id)}>
                                                <img src={deleteIcon} />
                                             </button>
                                          </div>

                                       </td>
                                    </tr>
                                 )
                              }
                              )
                           }
                        </tbody>
                     </table>
                  </div>

                  <Paginator
                     totalPages={totalPages}
                     pageNo={pageNo}
                     onPageChange={(e, no) => setPageNo(no)}
                     alignment="right"
                  />
               </div>


            </div>

         </div>

      </MainLayout>
   )

};



export default DoorstepServices;